module.exports = __webpack_public_path__ + "fonts/FSSinclair-Regular.c3d94cb2.otf";